import React from "react";
import styled from "styled-components";

import { HSpace, colorFromTheme } from "@examspark/common-ui/server";
import { Objective, ObjectivesItem, Replace } from "@examspark/types";

const StyledContainer = styled(HSpace)`
  gap: 0.5rem;
  align-items: center;
`;

const StyledLabel = styled.div`
  font-family: input-mono;
  font-size: 1em;
  text-align: left;
  flex-grow: 1;
`;

const StyledLeading = styled.div``;
const StyledTrailing = styled.div`
  text-align: right;
`;

const StyledWrapper = styled.div`
  display: inline-block;
  line-height: normal;
  margin: 0.1rem;
  padding: 0.2rem 0.5rem;
  /* border: 1px solid ${colorFromTheme("surface6")}; */
  color: ${colorFromTheme("text")};
`;

const PrintObjectiveBadge = (props: {
  objective?: Pick<Objective, "content" | "abbreviation"> | null;
  objectivesItem?: Replace<
    Pick<ObjectivesItem, "data" | "objective">,
    {
      objective?: Pick<Objective, "content" | "abbreviation"> | null;
    }
  > | null;
  leadingContent?: React.ReactNode;
  trailingContent?: React.ReactNode;
}) => {
  const objective = props.objective ?? props.objectivesItem?.objective;

  return (
    <StyledWrapper>
      <StyledContainer>
        {!!props.leadingContent && (
          <StyledLeading>{props.leadingContent}</StyledLeading>
        )}
        <StyledLabel>{objective?.abbreviation}</StyledLabel>
        {!!props.trailingContent && (
          <StyledTrailing>{props.trailingContent}</StyledTrailing>
        )}
      </StyledContainer>
    </StyledWrapper>
  );
};

export default PrintObjectiveBadge;
